/**
 * Firebase client SDK initialization. Auth (Google SSO + email/password) and
 * Firestore (live runtime-status subscriptions) share this single app instance.
 */
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const firestore = getFirestore(firebaseApp);
export const googleProvider = new GoogleAuthProvider();

/** Firestore collection holding per-instance runtime status docs. Must match the API. */
export const STATUS_COLLECTION =
  import.meta.env.VITE_FIRESTORE_STATUS_COLLECTION || 'integration_status';
